export const ucsfPrefixColumns = [
  'prefix',
  'iteration',
  'type',
  'ucsfPlanBilled',
  'effectiveStartDate',
  'effectiveEndDate',
];
